<template>
  <nav
    class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow"
    :class="{ toggled: toggledSidebar, fixed: fixedNavbar }">
    <button id="sidebarToggleTop" class="btn btn-link rounded-circle mr-3" @click="toggleSidebar">
      <i class="fas fa-bars" />
    </button>

    <h6 class="m-0 font-weight-bold text-primary text-uppercase">
      {{ $route.name }}
    </h6>

    <button
      class="btn btn-sm btn-warning font-weight-bold text-primary ml-3"
      v-show="$route.params.id"
      @click="$router.go(-1)">
      Kembali
      <i class="fas fa-arrow-circle-left" />
    </button>

    <div class="ml-3">
      <b-spinner variant="primary" label="Spinning" v-show="isLoading" />
    </div>

    <ul class="navbar-nav ml-auto">

      <h3 class="badge badge-primary mt-2 pt-2 d-none d-md-block" v-if="userCompanyName">
        {{ userCompanyName }}
      </h3>

      <h3 class="badge badge-primary mt-2 pt-2 d-none d-md-block" v-if="userDepartmentName">
        {{ userDepartmentName }}
      </h3>

      <div v-else>
        <h3
          v-if="$constant.APP === 'SINERGI'"
          class="badge badge-danger mt-2 pt-2"
          v-b-tooltip.hover
          title="Harap Hubungi Kepegawaian">
          Belum Ada Penempatan
        </h3>
      </div>

      <div class="topbar-divider d-none d-sm-block" />

      <b-dropdown class="dropdown no-arrow" variant="light">
        <template #button-content>
          <div class="form-row justify-content-md-center">
            <div class="d-flex align-items-center">
              <span class="mr-2 d-none d-lg-inline">{{ userName }}</span>
            </div>
            <div class="d-flex align-items-center">
              <i class="fas fa-2x fa-user-circle" />
            </div>
          </div>
        </template>

        <b-dropdown-item href="#" @click="$router.push(`/employee/profile/${employeeId}`)">
          <i class="fas fa-user fa-sm fa-fw mr-2" />
          Profile
        </b-dropdown-item>

        <b-dropdown-item @click="changePassword">
          <i class="fas fa-cogs fa-sm fa-fw mr-2" />
          Ubah Password
        </b-dropdown-item>

        <div class="dropdown-divider" />
        <b-dropdown-item @click="onLogout">
          <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2" />
          Logout
        </b-dropdown-item>
      </b-dropdown>
    </ul>

    <b-modal id="modalChangePassword" hide-footer hide-header>
      <FormChangePassword :id="userId" />
    </b-modal>
  </nav>
</template>

<script>
import FormChangePassword from '@/components/user/change-password.vue'

export default {
  data () {
    return {
      employeeData: {},
      employeeDepartment: ''
    }
  },
  components: { FormChangePassword },
  computed: {
    toggledSidebar () {
      return this.$store.state.collapsedSidebar
    },
    fixedNavbar () {
      return this.$store.state.fixedNavbar
    },
    isLoading () {
      return this.$store.state.isLoading
    },
    userId () {
      return this.$store.state.user.userData ? this.$store.state.user.userData.userId : null
    },
    userName () {
      return  this.$store.state.user.userData ? this.$store.state.user.userData.employee.Name : 'User'
    },
    employeeId () {
      return  this.$store.state.user.userData ? this.$store.state.user.userData.employee.ID : 0
    },
    userDepartmentName () {
      return this.$store.getters['user/userDepartment'].Name
    },
    userCompanyName () {
      return this.$store.getters['user/userCompany'].Name
    }
  },
  methods: {
    toggleSidebar () {
      this.$store.commit('toggleSidebar')
    },
    onLogout () {
      this.$store.commit('user/logout')
    },
    changePassword () {
      this.$bvModal.show('modalChangePassword')
    },
    // getEmployeeData () {
    //   this.$axios.get('/employee/get/' + this.userData.employeeId).then(({ data }) => {
    //     this.employeeData = data

    //     this.employeeDepartment = data.EmployeeAssignments[0].Department.Name
    //   })
    // }
  }
}
</script>

<style>

</style>
